import Vue from 'vue';
import orderProductTransformer from '../../transformers/orderProduct';
import all from './all';

const success = (data, id, resolve) => {
  console.log('[orderProduct/bulkStore] save ok, refetching order products for order id:', id);
  all(id);
  resolve();
};

const failed = (errors, reject) => {
  if (errors.error && errors.error.code) {
    reject(errors.error);
    return;
  }
  reject(orderProductTransformer.fetch(errors));
};

export default (id, orderProducts) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post(`/orders/${id}/products/bulk`, { items: orderProductTransformer.sendCollection(orderProducts) })
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/bulkStore.js